import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
const { PROCEDURE_15 } = environment;

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  getViewPdfByPath(path: any): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Document/Download?path=${path}`);
  }

  getViewPdfById(id: any): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Document/DownloadLicence/${id}`);
  }
}
